import React, { useState } from 'react';
import '../../styles/system/ClientSettings.css';

const ClientSettings = () => {
  const [form, setForm] = useState({
    nome: '',
    apelido: '',
    email: '',
    cpf: '',
    rg: '',
    data_nascimento: '',
    hora_nascimento: '',
    cidade_nascimento: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Enviar os dados para a API (futuro)
    console.log('Atualizar perfil:', form);
  };

  return (
    <div className="client-settings-container">
      <h2>Editar Informações Pessoais</h2>
      <form onSubmit={handleSubmit} className="client-settings-form">
        <input type="text" name="nome" placeholder="Nome completo" value={form.nome} onChange={handleChange} required />
        <input type="text" name="apelido" placeholder="Apelido" value={form.apelido} onChange={handleChange} />
        <input type="email" name="email" placeholder="E-mail" value={form.email} onChange={handleChange} required />
        <input type="text" name="cpf" placeholder="CPF" value={form.cpf} onChange={handleChange} required />
        <input type="text" name="rg" placeholder="RG" value={form.rg} onChange={handleChange} required />
        <input type="date" name="data_nascimento" value={form.data_nascimento} onChange={handleChange} required />
        <input type="time" name="hora_nascimento" value={form.hora_nascimento} onChange={handleChange} required />
        <input type="text" name="cidade_nascimento" placeholder="Cidade de nascimento" value={form.cidade_nascimento} onChange={handleChange} required />
        <button type="submit">Salvar Alterações</button>
      </form>
    </div>
  );
};

export default ClientSettings;
